export function detectBrowser() {
  const ua = navigator.userAgent;

  if (ua.includes('Firefox')) {
    return 'firefox' as const;
  }

  if (ua.includes('Safari') && !ua.includes('Chrome')) {
    return 'safari' as const;
  }

  return 'chrome' as const;
}
